import '../Admonition.less';
import type { admonitionTag } from '../plugins/remark-directive-extension-lib/remark-admonition';
import { FoxIconCheck, FoxIconError1, FoxIconInfo2, FoxIconLightbulb, FoxIconNote, FoxIconWarning01, FoxIconWarning02 } from 'aui-biz-icons';
export const AdmonitionConfig: Record<(typeof admonitionTag)[number], { icon: JSX.Element }> = {
  note: {
    icon: <FoxIconNote className="mr-2" size={16} />,
  },
  tip: {
    icon: <FoxIconLightbulb className="mr-2" size={16} />,
  },
  check: {
    icon: <FoxIconCheck className="mr-2" size={16} />,
  },
  info: {
    icon: <FoxIconInfo2 className="mr-2" size={16} />,
  },
  caution: {
    icon: <FoxIconWarning01 className="mr-2" size={16} />,
  },
  warning: {
    icon: <FoxIconWarning02 className="mr-2" size={16} />,
  },
  danger: {
    icon: <FoxIconError1 className="mr-2" size={16} />,
  },
};
